module.exports = __webpack_public_path__ + "img/learning-the-language.a0aaf261.png";